export { default } from './GroupsSearchCollector';



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchNewCollector/index.js